import { createContext, useContext } from 'react'

export const GridContext = createContext({ gutters: 15, columns: 12 })

const useGridContext = () => {
  return useContext(GridContext)
}

export default useGridContext
